import { styled } from 'styles';

export const Container = styled.div`
  user-select: none;
`;

export const LegendList = styled.ul`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`;

export const LegendItem = styled.li<{ color: string | undefined }>`
  font-size: 1.2rem;
  border-bottom: 2px solid ${({ color }) => color};
  margin-right: 16px;
`;
